function initCookies()
{
  const cs = getCookie("cs");
  if (!cs) {
    document.getElementById("js_dataNnoticeBtns").classList.remove("d-none");
    document.getElementById("js_dataNnoticeBackdrop").classList.remove("d-none");
  } else {
     if(typeof cs === "string") {
      const c = JSON.parse(cs);
      if( typeof c === "object" && c.fa === true) {
        analytics();
      }
      if( typeof c === "object" && c.ma === true) {
        gtag('consent', 'update', {
          'ad_storage': 'granted',
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'analytics_storage': 'granted'     
        });
      }
    }
  }

  if (document.getElementById("js_cookieSettings")) {

    document.getElementById("js_cookieSettings").addEventListener("click", function() {
      document.getElementById("js_dataNoticeSettings").classList.toggle("show");
      document.getElementById("js_dataNnoticeBtns").classList.toggle("active");
      document.getElementById("js_dataNnoticeBackdrop").classList.toggle("active");
    });

    /*document.getElementById("js_cookieSettings2").addEventListener("click", function() {
      document.getElementById("js_dataNoticeSettings").classList.toggle("show");
      document.getElementById("js_dataNnoticeBtns").classList.toggle("active");
      document.getElementById("js_dataNnoticeBackdrop").classList.toggle("active");
    });*/

    document.getElementById("js_saveCookieSettings").addEventListener("click", function() {
      const dataPrivacySettigs = {
        fa : document.getElementById("fa_cookies").checked,
        some : document.getElementById("some_cookies").checked,
        ma : document.getElementById("ma_cookies").checked
      };
      saveCookieSettings(dataPrivacySettigs);
    });

    document.getElementById("js_cookieSettings3").addEventListener("click", function() {
      const dataPrivacySettigs = {
        fa : false,
        some : false,
        ma: false
      };
      saveCookieSettings(dataPrivacySettigs);
    });

    /*document.getElementById("js_declineCookieSettings").addEventListener("click", function() {
      saveCookieSettings( { fa : false, some : false, cc : "" });
    });*/

    document.getElementById("js_acceptCookieSettings").addEventListener("click", function() {
      saveCookieSettings( { fa : true, some : true, ma: true });
    });
  }


  initCheckIE11();
}

function someCookiesAllowed()
{
  const cookieSettings = getCookie("cs");
  if (typeof cookieSettings !== "string" || cookieSettings.length === 0) {
    return false;
  }

  const settings = JSON.parse(cookieSettings);
  return (typeof settings === "object" && settings.some === true);
}

function allowSomeCookies()
{
  const cookieSettings = getCookie("cs");

  let settings = {};
  if (typeof cookieSettings !== "string" || cookieSettings.length === 0) {
    settings = { fa : true, some : true, ma: true, cc : "" };
  } else {
    settings = JSON.parse(cookieSettings);
  }

  settings.some = true;

  saveCookieSettings(settings);
}

function updateUsersCc( cc )
{
  const cookieSettings = getCookie("cs");

  let settings = {};
  if (typeof cookieSettings !== "string" || cookieSettings.length === 0) {
    settings = { fa : true, some : true, ma: true, cc : "" };
  } else {
    settings = JSON.parse(cookieSettings);
  }

  settings.cc = cc.toLowerCase();

  saveCookieSettings(settings, false);
}


function saveCookieSettings( dataPrivacySettigs, updateCc )
{
  if(typeof updateCc === "undefined") {
    updateCc = true;
  }

  const days = 30;
  const d = new Date();
  d.setTime(d.getTime()+(days*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();

  if (updateCc && typeof dataPrivacySettigs.fa === "boolean" && dataPrivacySettigs.fa === true) {
    setUsersCc();
  }

  document.cookie = "cs="+JSON.stringify(dataPrivacySettigs)+";" + expires + "; path=/";
  document.getElementById("js_dataNoticeSettings").classList.remove("show");
  document.getElementById("js_dataNnoticeBtns").classList.add("d-none");
  document.getElementById("js_dataNnoticeBackdrop").classList.add("d-none");

  if(dataPrivacySettigs.fa === true) {
    setTimeout(window.location.reload(), 500);
  }
}

function setUsersCc()
{
  const request_data = {};
  const v = new Date();
  request_data.action = "get_users_cc";
  request_data.v = v.getTime();

  $.ajax(
  {
      url: xhrUrl,
      type: 'GET',
      data: request_data,
      dataType: 'JSON',
      success: function(response) {
        // _log("response");
        // _log(response);
        if ( typeof response === "object" && typeof response.cc === "string") {
          updateUsersCc(response.cc);
        }
      },
  });
}

function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function initCheckIE11()
{
  const isIe11 = !!window.MSInputMethodContext && !!document.documentMode;
  // const isIe11 = true;
  const cookieSettings = getCookie("ie11");

  if (isIe11 && !cookieSettings) {
    $('#ie11Modal').modal('show');

    document.getElementById("ie11Modal").addEventListener("click", function() {
      const days = 1;
      const d = new Date();
      d.setTime(d.getTime()+(days*24*60*60*1000));
      var expires = "expires="+ d.toUTCString();
      document.cookie = "ie11=1;" + expires + "; path=/";
      }
    );
  }
}


function analytics()
{
  ga('create', 'UA-60042828-1', 'auto');
  ga('send', 'pageview');

  gtag('consent', 'update', {
    'analytics_storage': 'granted'
  });

  twq('init','o8kmz');
  twq('track','PageView');

  fbq('init', '3180037785647723'); 
  fbq('track', 'PageView');

  if (typeof window.clarity === 'function') {
    window.clarity('consent');
  }
}


export { initCookies, saveCookieSettings, getCookie, someCookiesAllowed, allowSomeCookies };